// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define the default font and layout */
body {
  font-family: Arial, Helvetica, sans-serif;
  margin: 0;
  padding: 0;
}

/* Container for cards */
.card-comp {
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* Center cards horizontally */
  gap: 15px; /* Add gap between cards */
  padding: 10px; /* Add padding around the container */
}

/* Card styles */
.card {
  background: linear-gradient(135deg, #c2f598, #e9e8e8, #f3ab7b); /* Gradient background */
  border-radius: 12px; /* Rounded corners */
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  padding: 10px; /* Adjusted padding */
  text-align: center;
  max-width: 240px; /* Maximum width of the card */
  width: calc(50% - 15px); /* Set width to fit two cards per row with gap */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Space out card content */
  position: relative; /* Position relative for absolute positioning of message */
  box-sizing: border-box; /* Ensure padding is included in width/height */
}

/* Image inside the card */
.card img {
  width: 100%; /* Ensure image scales with card width */
  height: auto; /* Maintain aspect ratio */
  max-height: 150px; /* Limit image height */
  object-fit: cover; /* Crop image to fit */
  border-radius: 8px; /* Rounded corners for the image */
}

/* Content inside the card */
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1; /* Allow content to grow and fill available space */
}

/* Product price styling */
.product-price {
  color: #444; /* Darker color for better readability */
  margin: 10px 0;
  font-size: 1.2em; /* Increase font size */
}

/* Button styles */
.button-card {
  background-color: #1b72d4; /* Blue button color */
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  padding: 12px 24px; /* Increase padding */
  text-transform: uppercase;
  font-weight: bold;
  transition: background-color 0.3s, transform 0.3s;
}

.button-card:hover {
  background-color: #218838; /* Darker green on hover */
  transform: scale(1.05);
}

.button-card.disabled {
  background-color: #6c757d; /* Gray color to indicate disabled state */
  cursor: not-allowed; /* Change cursor to indicate disabled state */
  pointer-events: none; /* Disable all mouse events */
}

/* Media queries for responsiveness */

/* For large screens */
@media (min-width: 1025px) {
  .card-comp {
    gap: 20px; /* Increase gap for larger screens */
  }
}

/* For tablets and smaller desktops */
@media (max-width: 1024px) {
  .card-comp {
    /* Use flex layout to wrap cards */
    flex-direction: row;
  }
}

/* For mobile screens */
@media (max-width: 768px) {
  .card {
    width: calc(100% - 15px); /* Adjust width to ensure one card per row */
    padding: 15px; /* Adjust padding for better spacing */
  }

  .card img {
    max-height: 120px; /* Limit image height on mobile */
  }

  .product-price {
    font-size: 1em; /* Adjust font size for better readability on mobile */
  }
}

/* For extra small screens */
@media (max-width: 480px) {
  .card {
    width: calc(100% - 10px); /* Full width with slight margin */
    padding: 10px; /* Reduce padding for very small screens */
  }

  .card img {
    max-height: 100px; /* Further limit image height */
  }

  .product-price {
    font-size: 0.9em; /* Further reduce font size */
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Card/Card.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB,EAAE,8BAA8B;EACvD,SAAS,EAAE,0BAA0B;EACrC,aAAa,EAAE,qCAAqC;AACtD;;AAEA,gBAAgB;AAChB;EACE,8DAA8D,EAAE,wBAAwB;EACxF,mBAAmB,EAAE,oBAAoB;EACzC,2CAA2C,EAAE,qBAAqB;EAClE,aAAa,EAAE,qBAAqB;EACpC,kBAAkB;EAClB,gBAAgB,EAAE,8BAA8B;EAChD,uBAAuB,EAAE,gDAAgD;EACzE,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,2BAA2B;EAC3D,kBAAkB,EAAE,0DAA0D;EAC9E,sBAAsB,EAAE,+CAA+C;AACzE;;AAEA,0BAA0B;AAC1B;EACE,WAAW,EAAE,wCAAwC;EACrD,YAAY,EAAE,0BAA0B;EACxC,iBAAiB,EAAE,uBAAuB;EAC1C,iBAAiB,EAAE,sBAAsB;EACzC,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,mDAAmD;AACnE;;AAEA,0BAA0B;AAC1B;EACE,WAAW,EAAE,wCAAwC;EACrD,cAAc;EACd,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE,qBAAqB;EACzC,yBAAyB;EACzB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,0CAA0C;EACrE,mBAAmB,EAAE,6CAA6C;EAClE,oBAAoB,EAAE,6BAA6B;AACrD;;AAEA,qCAAqC;;AAErC,sBAAsB;AACtB;EACE;IACE,SAAS,EAAE,oCAAoC;EACjD;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,wBAAwB,EAAE,4CAA4C;IACtE,aAAa,EAAE,sCAAsC;EACvD;;EAEA;IACE,iBAAiB,EAAE,iCAAiC;EACtD;;EAEA;IACE,cAAc,EAAE,sDAAsD;EACxE;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,wBAAwB,EAAE,kCAAkC;IAC5D,aAAa,EAAE,0CAA0C;EAC3D;;EAEA;IACE,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,gBAAgB,EAAE,6BAA6B;EACjD;AACF","sourcesContent":["/* Define the default font and layout */\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n/* Container for cards */\n.card-comp {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center; /* Center cards horizontally */\n  gap: 15px; /* Add gap between cards */\n  padding: 10px; /* Add padding around the container */\n}\n\n/* Card styles */\n.card {\n  background: linear-gradient(135deg, #c2f598, #e9e8e8, #f3ab7b); /* Gradient background */\n  border-radius: 12px; /* Rounded corners */\n  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.2); /* Shadow for depth */\n  padding: 10px; /* Adjusted padding */\n  text-align: center;\n  max-width: 240px; /* Maximum width of the card */\n  width: calc(50% - 15px); /* Set width to fit two cards per row with gap */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Space out card content */\n  position: relative; /* Position relative for absolute positioning of message */\n  box-sizing: border-box; /* Ensure padding is included in width/height */\n}\n\n/* Image inside the card */\n.card img {\n  width: 100%; /* Ensure image scales with card width */\n  height: auto; /* Maintain aspect ratio */\n  max-height: 150px; /* Limit image height */\n  object-fit: cover; /* Crop image to fit */\n  border-radius: 8px; /* Rounded corners for the image */\n}\n\n/* Content inside the card */\n.card-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1; /* Allow content to grow and fill available space */\n}\n\n/* Product price styling */\n.product-price {\n  color: #444; /* Darker color for better readability */\n  margin: 10px 0;\n  font-size: 1.2em; /* Increase font size */\n}\n\n/* Button styles */\n.button-card {\n  background-color: #1b72d4; /* Blue button color */\n  border: none;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  padding: 12px 24px; /* Increase padding */\n  text-transform: uppercase;\n  font-weight: bold;\n  transition: background-color 0.3s, transform 0.3s;\n}\n\n.button-card:hover {\n  background-color: #218838; /* Darker green on hover */\n  transform: scale(1.05);\n}\n\n.button-card.disabled {\n  background-color: #6c757d; /* Gray color to indicate disabled state */\n  cursor: not-allowed; /* Change cursor to indicate disabled state */\n  pointer-events: none; /* Disable all mouse events */\n}\n\n/* Media queries for responsiveness */\n\n/* For large screens */\n@media (min-width: 1025px) {\n  .card-comp {\n    gap: 20px; /* Increase gap for larger screens */\n  }\n}\n\n/* For tablets and smaller desktops */\n@media (max-width: 1024px) {\n  .card-comp {\n    /* Use flex layout to wrap cards */\n    flex-direction: row;\n  }\n}\n\n/* For mobile screens */\n@media (max-width: 768px) {\n  .card {\n    width: calc(100% - 15px); /* Adjust width to ensure one card per row */\n    padding: 15px; /* Adjust padding for better spacing */\n  }\n\n  .card img {\n    max-height: 120px; /* Limit image height on mobile */\n  }\n\n  .product-price {\n    font-size: 1em; /* Adjust font size for better readability on mobile */\n  }\n}\n\n/* For extra small screens */\n@media (max-width: 480px) {\n  .card {\n    width: calc(100% - 10px); /* Full width with slight margin */\n    padding: 10px; /* Reduce padding for very small screens */\n  }\n\n  .card img {\n    max-height: 100px; /* Further limit image height */\n  }\n\n  .product-price {\n    font-size: 0.9em; /* Further reduce font size */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
